import { useState, useEffect } from 'react';

/**
 * Custom hook for managing rejected file state with auto-clear timeout
 * @param {number} timeout - Timeout duration in milliseconds (default: 3000)
 * @returns {[any, function]} - [rejectedState, setRejectedState]
 */
const useRejectedFileTimeout = (timeout = 3000) => {
  const [rejectedState, setRejectedState] = useState([]);

  useEffect(() => {
    if (rejectedState && rejectedState.length > 0) {
      const timer = setTimeout(() => {
        setRejectedState([]);
      }, timeout);

      return () => clearTimeout(timer);
    }
  }, [rejectedState, timeout]);

  return [rejectedState, setRejectedState];
};

export default useRejectedFileTimeout;
